<div class="mt-2">
  <div class="text-base leading-lg font-bold mb-[12px] skeleton-item">{{ 'marketplace.asset.saasApiKey.title' | transloco }}</div>
  <div class="container api-key mt-[12px] skeleton-item" *yatVar="apiKeys[0] as apiKey">
    <input type="password" #passwordInput [value]="apiKey" class="flex-1" disabled="true" />
    <div>
      <yat-copy-to-clipboard id="1d4861b4-f352-4dcc-92b6-82cb467ab1d4" *ngIf="apiKey" [content]="apiKey" class="pr-2 ml-2 border-r-2 border-r-n-30"></yat-copy-to-clipboard>
      <yat-visible-input id="1ea21207-8a42-437a-9f74-f6b6e821d300" [content]="apiKey ?? undefined" [inputElement]="passwordInput" class="pl-2"></yat-visible-input>
    </div>
  </div>
  <ng-container *ngIf="showRegenerateApiButton">
    <button (click)="prepareRegenerate()" yat-button class="text-[12px] leading-base text-n-40 mt-1 cursor-pointer" *ngIf="regenerateMode === 'default'">
      <span class="mr-1.5">{{ 'marketplace.asset.saasApiKey.regenerate' | transloco }}</span>
    </button>
    <yat-confirm-buttons
      [confirmButtonName]="'marketplace.asset.saasApiKey.regenerate' | transloco"
      (confirmClickMethod)="regenerateApiKey($event)"
      (cancelClickMethod)="cancelRegenerate()"
      *ngIf="regenerateMode !== 'default'"></yat-confirm-buttons>
  </ng-container>
  <div class="text-base leading-lg font-bold my-[12px] mt-6 skeleton-item">{{ 'marketplace.asset.saasApiKey.endpointUrl' | transloco }}</div>
  <div class="container skeleton-item mb-6" *ngIf="product?.saasApiConfigurationModel?.primaryEndpointUrl as primaryEndpointUrl">
    <span>{{ primaryEndpointUrl }}</span>
    <yat-copy-to-clipboard id="45e20f09-60c2-417d-8851-2b0eb25f1015" [content]="primaryEndpointUrl"></yat-copy-to-clipboard>
  </div>
  <div *ngIf="showDescription && product?.saasApiConfigurationModel?.description as description" class="text-base leading-lg mb-6 skeleton-item">
    <p class="font-bold">{{ 'marketplace.asset.saasApiKey.description' | transloco }}</p>
    <p>{{ description }}</p>
  </div>
  <div yat-link *ngIf="product?.saasApiConfigurationModel?.documentationUrl as documentationUrl" class="text-base leading-lg mb-6 skeleton-item">
    <transloco
      id="f1d1e5c6-38c2-4c15-85a7-0b55f467b8ad"
      key="marketplace.asset.saasApiKey.youCanFindValuableInformationUnder"
      [params]="{
        documentationLink: {
          url: documentationUrl,
          class: 'link link-primary !text-base !leading-lg',
          target: '_blank',
          id: '894d0f3c-e4c1-4ead-aaf8-ef76859bc5ab'
        },
      }"></transloco>
  </div>
</div>
